import type { FC } from 'react';
import React from 'react';
import { formatCurrency } from 'src/utils/stringUtils';
import styled from 'styled-components';

export interface IDeparture {
  text: string;
  link: string;
  price: number | string;
}

interface Props {
  departureList: IDeparture[];
}

export const DepartureList: FC<Props> = ({ departureList }) => (
  <SubContainer>
    {departureList.map((dep) => (
      <StyledWrapper key={dep.link}>
        <StyledAnchor href={dep.link}>{dep.text}</StyledAnchor>
        <StyledPrice>{`от ${formatCurrency(dep.price)}`}</StyledPrice>
      </StyledWrapper>
    ))}
  </SubContainer>
);

const SubContainer = styled.div`
  width: 100%;
  font-size: 14px;
  line-height: 16px;

  &:first-child {
    margin-right: 28px;
  }
`;

const StyledWrapper = styled.div`
  margin-bottom: 6px;
  display: flex;
`;

const StyledAnchor = styled.a`
  text-decoration: none;
  color: #007aff;
`;

const StyledPrice = styled.span`
  margin-left: auto;
`;
